function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.41 3.542a2.14 2.14 0 003.18 0l1.035-1.136a2.142 2.142 0 013.73 1.546l-.078 1.531A2.142 2.142 0 0022.52 7.73l1.532-.078a2.143 2.143 0 011.542 3.73l-1.14 1.028a2.142 2.142 0 000 3.181l1.14 1.029a2.143 2.143 0 01-1.546 3.73l-1.531-.078a2.145 2.145 0 00-2.109 1.37c-.108.28-.155.579-.14.878l.078 1.532a2.143 2.143 0 01-3.721 1.542l-1.03-1.139a2.143 2.143 0 00-3.18 0l-1.033 1.139a2.143 2.143 0 01-3.726-1.54l.079-1.531a2.141 2.141 0 00-2.249-2.25l-1.531.079a2.14 2.14 0 01-1.549-3.727l1.139-1.028a2.143 2.143 0 000-3.182l-1.139-1.033a2.142 2.142 0 011.541-3.726l1.532.078a2.142 2.142 0 002.25-2.253l-.073-1.532a2.143 2.143 0 013.726-1.543l1.028 1.136z",
  stroke: "currentColor",
  strokeWidth: "1.4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.078 14.001a4.922 4.922 0 109.844 0 4.922 4.922 0 00-9.844 0z",
  stroke: "currentColor",
  strokeWidth: "1.4",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));